/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_PriceInputs */

const id_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const ms_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const da_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const de_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const en_us2_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const es_es2_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const es_mx2_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fil_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presyo`)
};

const fr_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const it_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

const hu_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ár`)
};

const nl_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs`)
};

const no_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const pl_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const pt_br2_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const pt_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const ro_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț`)
};

const fi_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinta`)
};

const sv_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const vi_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá`)
};

const tr_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat`)
};

const cs_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const bg_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const ru_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const uk_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ціна`)
};

const ar_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر`)
};

const hi_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमत`)
};

const th_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา`)
};

const ja_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格`)
};

const zh_cn2_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const zh_hant1_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`價格`)
};

const ko_search_sort_price = /** @type {(inputs: Search_Sort_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Search_Sort_PriceInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_price = /** @type {((inputs?: Search_Sort_PriceInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_PriceInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_price(inputs)
	if (locale === "ms") return ms_search_sort_price(inputs)
	if (locale === "da") return da_search_sort_price(inputs)
	if (locale === "de") return de_search_sort_price(inputs)
	if (locale === "en-US") return en_us2_search_sort_price(inputs)
	if (locale === "es-ES") return es_es2_search_sort_price(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_price(inputs)
	if (locale === "fil") return fil_search_sort_price(inputs)
	if (locale === "fr") return fr_search_sort_price(inputs)
	if (locale === "it") return it_search_sort_price(inputs)
	if (locale === "hu") return hu_search_sort_price(inputs)
	if (locale === "nl") return nl_search_sort_price(inputs)
	if (locale === "no") return no_search_sort_price(inputs)
	if (locale === "pl") return pl_search_sort_price(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_price(inputs)
	if (locale === "pt") return pt_search_sort_price(inputs)
	if (locale === "ro") return ro_search_sort_price(inputs)
	if (locale === "fi") return fi_search_sort_price(inputs)
	if (locale === "sv") return sv_search_sort_price(inputs)
	if (locale === "vi") return vi_search_sort_price(inputs)
	if (locale === "tr") return tr_search_sort_price(inputs)
	if (locale === "cs") return cs_search_sort_price(inputs)
	if (locale === "bg") return bg_search_sort_price(inputs)
	if (locale === "ru") return ru_search_sort_price(inputs)
	if (locale === "uk") return uk_search_sort_price(inputs)
	if (locale === "ar") return ar_search_sort_price(inputs)
	if (locale === "hi") return hi_search_sort_price(inputs)
	if (locale === "th") return th_search_sort_price(inputs)
	if (locale === "ja") return ja_search_sort_price(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_price(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_price(inputs)
	return ko_search_sort_price(inputs)
});
export { search_sort_price as "search.sort.price" }